export type EdiConnectionType = 'sftp' | 'api';
export type EdiMessageType = 'csv' | 'xml';
export type EdiConfirmationType = 'csv' | 'xml';
